import React from 'react';
import PropTypes from 'prop-types';
import './main.less';

import moment from 'moment';

import SwitchControlMulti from '../../../../shared/switch-control/multi/main';
import Calendar from '../../../../shared/calendar/main';

import Table from '../../../../shared/new-table/main';
import withIntl, { IntlPropType } from '../../../../shared/intl-hoc';

import table from './table-initial-data';

function DashboardVisits({ intl, calendar, data, rows, total, apply, showMore, ...props }) {
	return (
		<div>
			{data && (
				<table className='dashboard-visits-signup-data'>
					<tbody>
						<tr>
							<td>action</td>
							<td>{data.action}</td>
						</tr>
						<tr>
							<td>link</td>
							<td>{data.link}</td>
						</tr>
						<tr>
							<td>referer</td>
							<td>{data.referer}</td>
						</tr>
						<tr>
							<td>date</td>
							<td>{moment(data.date).format('DD.MM.YYYY HH:mm')}</td>
						</tr>
					</tbody>
				</table>
			)}
			<div className='dashboard-visits-filters'>
				<SwitchControlMulti
					intl={intl}
					filters={props.actionsSwitchControlMultiItems}
					choose={filterValue => {
						props.switchActions(filterValue);
						apply();
					}}
				/>
				<Calendar
					intl={intl}
					dateRange={calendar.dateRange}
					isOpen={calendar.isOpen}
					ranges={calendar.ranges}
					startDate={calendar.startDate}
					endDate={calendar.endDate}
					onInit={calendar.calendarInit}
					onToggle={calendar.calendarToggle}
					onChange={calendar.calendarChange}
					onApply={calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={() => apply()}
				>
					{intl('Apply')}
				</button>
			</div>
			{rows.length ? (
				<Table
					className='dashboard-visits-table'
					table={table}
					rows={rows.map((row) => ({ id: row.date, ...row }))}
				/>
			) : (
				<div className='dashboard-visits-empty'>
					No data
				</div>
			)}
			{(rows.length < total) && (
				<div className="dashboard-visits-button-wrapper">
					<button
						className="ui-btn ui-btn-secondary dashboard-visits-button"
						onClick={showMore}
					>
						{intl('Show more')}
					</button>
				</div>
			)}
		</div>
	);
}

DashboardVisits.propTypes = {
	intl: IntlPropType,
	actionsSwitchControlMultiItems: PropTypes.array.isRequired,
	switchActions: PropTypes.func.isRequired,
	calendar: PropTypes.object.isRequired,
	data: PropTypes.object,
	rows: PropTypes.array.isRequired,
	total: PropTypes.number.isRequired,
	apply: PropTypes.func.isRequired,
	showMore: PropTypes.func.isRequired
};

export default withIntl(DashboardVisits);


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/dashboard-visits/main.js